'use client'

import { useEffect } from 'react'

const Modal = ({
  children,
  onClick,
  className,
}: {
  children?: React.ReactNode
  className?: string
  onClick?: () => void
}) => {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClick?.()
      }
    }

    document.addEventListener('keydown', handleEsc)

    return () => {
      document.removeEventListener('keydown', handleEsc)
    }
  }, [onClick])

  return (
    <div
      className={`fixed inset-0 bg-black/70 backdrop-blur-sm flex justify-center items-center z-100 px-4 sm:px-0 `}
      onClick={onClick} // يقفل لو دوست برا
    >
      <div
        className={`glass-effect border border-[#d9ac4f]/30 ${className} px-[32px] py-[24px]  rounded-[24px] h-fit  w-[536px] relative text-center`}
        onClick={(e) => e.stopPropagation()} // يمنع القفل لما تدوس جوه
      >
        {children}
      </div>
    </div>
  )
}

export default Modal
